/**
 * Client-side mirror of combat/counterStrikeResolution.js
 */

function findPlayedUnitByInstanceId(playerState, instanceId) {
  if (!playerState?.playedOrders || instanceId == null) {
    return null;
  }
  for (const zone of ['front', 'flank']) {
    const units = playerState.playedOrders[zone] || [];
    for (const unit of units) {
      if (unit && String(unit.instanceId) === String(instanceId)) {
        return unit;
      }
    }
  }
  return null;
}

function orderLooksLikeCounterStrikeDraw(order) {
  if (!order) {
    return false;
  }
  if (order.isCounterStrike === true) {
    return true;
  }
  const abilities = Array.isArray(order.abilities) ? order.abilities : [];
  return abilities.includes('Counter Strike');
}

function hasPendingCounterStrikeDraws(playerState) {
  const pending = playerState?.pendingCounterStrike || [];
  return pending.some(orderLooksLikeCounterStrikeDraw);
}

export function isCounterStrikeDeployTargetingActive(playerState) {
  if (!playerState?.deployTargetMode || !playerState.selectedDeployInstanceId) {
    return false;
  }
  const unit = findPlayedUnitByInstanceId(playerState, playerState.selectedDeployInstanceId);
  return unit?.isCounterStrike === true;
}

export function isCounterStrikeStrategemTargetingActive(playerState) {
  const info = playerState?.needsStrategemTarget;
  if (!info) {
    return false;
  }
  if (info.isCounterStrikeStrategem === true) {
    return true;
  }
  const strategem = (playerState.hand || []).find(
    (order) => order && String(order.instanceId) === String(info.strategemInstanceId)
  );
  return strategem?.isCounterStrikeStrategem === true || strategem?.isCounterStrike === true;
}

export function isCounterStrikeTargetingActive(playerState) {
  return (
    isCounterStrikeStrategemTargetingActive(playerState) ||
    isCounterStrikeDeployTargetingActive(playerState)
  );
}

export function isPlayerResolvingCounterStrike(playerState) {
  if (!playerState) {
    return false;
  }
  if (hasPendingCounterStrikeDraws(playerState)) {
    return true;
  }
  return isCounterStrikeTargetingActive(playerState);
}

export function isOpponentResolvingCounterStrike(gameState, userId) {
  if (!gameState?.players || !gameState.state) {
    return false;
  }
  const opponentId = gameState.players.find((id) => id !== userId);
  if (!opponentId) {
    return false;
  }
  return isPlayerResolvingCounterStrike(gameState.state[opponentId]);
}
